<template>
    <div class="h-100">
        <open-project v-for="(item) in openProjects" :key="item.projectId" :project-id="item.projectId" v-show="item.projectId===activeProjectId" ref="openProjects"></open-project>
    </div>
</template>

<script>
    import OpenProject from "@/views/OpenProject";
    import {Promise} from 'es6-promise-polyfill'
    import {authHelper} from "@/utils";

    export default {
        name: "ProjectsManager",
        components: {OpenProject},
        methods: {
            onActiveProjectIdChange() {
                if (!this.activeProjectId) {
                    return;
                }
                const canAccessProjects = authHelper.getCanAccessProjects();
                if (canAccessProjects.indexOf(this.activeProjectId) === -1) {
                    this.$router.push({name: 'home'})
                    return;
                }
                let i, len = this.openProjects.length;
                for (i = 0; i < len; i++) {
                    if (this.openProjects[i].projectId === this.activeProjectId) {
                        return;
                    }
                }
                this.openProjects.push({
                    projectId: this.activeProjectId,
                })
            },
            closeAllTabs() {
                let p = Promise.resolve();

                if (!this.openProjects.length) {
                    return p;
                }

                const openProjectsRef = this.$refs.openProjects;
                let i;
                let len = openProjectsRef.length;

                for (i = 0; i < len; i++) {
                    (function (i) {
                        p = p.then(() => {
                        return openProjectsRef[i].closeAllTabs();
                    })
                    })(i)
                }

                return p;
            },
            closeAllTabsSwiftly() {
                const openProjectsRef = this.$refs.openProjects;
                if (!openProjectsRef) {
                    return;
                }
                let i;
                let len = openProjectsRef.length;

                for (i = 0; i < len; i++) {
                    openProjectsRef[i].closeAllTabsSwiftly();
                }
            }
        },
        data() {
            return {
                openProjects: [],
            }
        },
        props: {
            activeProjectId: String,
        },
        watch: {
            activeProjectId: {
                handler() {
                    this.onActiveProjectIdChange();
                },
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
